export default [
    {
        path: '/resource-planner',
        name: 'ResourcePlanner',
        component: () => import('../ResourcePlannerComponent.vue'),
        meta: {
            layout: 'default',
            requiresAuth: true,
            requiresRole: [1], 
        }
    }
]
